// extracted by mini-css-extract-plugin
module.exports = {"wrap404":"PageNotFound_wrap404__Tm6X0","notFoundMsg":"PageNotFound_notFoundMsg__5NpJq"};